import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchSignupSubscribersList,
  clearSignupSubscribersList,
  fetchSignupSubscribersCsv,
  clearFetchSignupSubscribersCsv,
} from 'redux/signup-generator/actions';

import { Link } from 'react-router-dom';

import DashboardFormSection from 'components/dashboard/common/DashboardFormSection';
import DownloadButton from 'components/elements/buttons/DownloadButton';
import CommonTable from 'components/elements/tables/common-table/CommonTable';
import Pagination from 'components/common/Pagination';
import CommonMessage from 'components/common/CommonMessage';

import { performDownload } from 'utils/common';

import './SignupSubscribersList.css';

const SignupSubscribersList = ({
  me,
  signupSubscribersList,
  signupSubscribersListError,
  fetchSignupSubscribersList,
  clearSignupSubscribersList,
  fetchSignupSubscribersCsv,
  clearFetchSignupSubscribersCsv,
  signupSibscribersCsv,
}) => {
  const [ tableData, setTableData ] = useState(null);
  const [ activePaginationPage, setActivePaginationPage ] = useState(0);

  useEffect(() => {
    fetchSignupSubscribersList();
    return () => {
      clearSignupSubscribersList();
      clearFetchSignupSubscribersCsv();
    };
  }, []);

  useEffect(() => {
    setTableData(signupSubscribersList);
  }, [signupSubscribersList]);

  useEffect(() => {
    if (signupSibscribersCsv) {
      performDownload(`subscribers.csv`, signupSibscribersCsv);
      setTimeout(() => {
        clearFetchSignupSubscribersCsv();
      }, 3000);
    }
  }, [signupSibscribersCsv]);

  const handlePaginationPageClick = date => {
    const _date = date.selected + 1;
    fetchSignupSubscribersList(_date);
    setActivePaginationPage(date.selected);
  };

  const isPro = me && me.subscription && me.subscription.ff_signup_generator;

  const renderTableData = data => {
    if (!tableData) return null;

    return (
      <Translation>
        {(t) => (
          <Fragment>
            <CommonTable className="mobile-1024">
              <CommonTable.Header>
                <CommonTable.Cell>{t("#")}</CommonTable.Cell>
                <CommonTable.Cell>{t("Email Address")}</CommonTable.Cell>
                <CommonTable.Cell>{t("Date Added")}</CommonTable.Cell>
              </CommonTable.Header>

              {data && data.results.length > 0 && data.results.map((item, index) => (
                <CommonTable.Row
                  className={(index > 2 && !isPro) ? 'blocked' : ''}
                  key={`email_signup_subscribers_list_table_row_key_${item.id}`}
                >
                  <CommonTable.Cell>
                    <div className="parameter">{t("#")}</div>
                    <div className="value">{activePaginationPage*30 + index + 1}</div>
                  </CommonTable.Cell>
                  <CommonTable.Cell className="email">
                    <div className="parameter">{t("Email Address")}</div>
                    <div className="value">
                      <a href={(index > 2 && !isPro) ? '#' : `mailto:${item.email}`}>
                        {item.email}
                      </a>
                    </div>
                  </CommonTable.Cell>
                  <CommonTable.Cell>
                    <div className="parameter">{t("Date Added")}</div>
                    <div className="value">{item.created_at}</div>
                  </CommonTable.Cell>
                </CommonTable.Row>
              ))}
            </CommonTable>

            {tableData && tableData.results && tableData.results.length === 0 &&
              <CommonMessage info>
                {t("You don't have any sign ups or subscribers yet…")}
              </CommonMessage>
            }
          </Fragment>
        )}
      </Translation>
    );
  };

  return (
    <Translation>
      {(t) => (
        <DashboardFormSection
          header={t("SIGNUPS & SUBSCRIBERS")}
          className="email-signup-subscribers-list__component"
        >
          {!isPro && tableData && tableData.count > 3 &&
            <div className="blocked-text">
              <div className="icon" />
              <div className="text">
                {t("All subscribers are available on the PRO plan. Check it")} <Link to="/billing">{t("here")}</Link>
              </div>
            </div>
          }

          <div className="email-signup-subscribers-list-content">
            {renderTableData(tableData)}

            <div className="table-footer">
              {tableData && tableData.count > 0 &&
                <DownloadButton onClick={() => fetchSignupSubscribersCsv() }>
                  {t("Export to CSV")}
                </DownloadButton>
              }

              {tableData && tableData.count > 30 && isPro &&
                <Pagination
                  containerClassName={'email-signup-subscribers-paginator'}
                  activeClassName={'active'}
                  pageCount={ Math.ceil(tableData.count / 30)}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={handlePaginationPageClick}
                />
              }
            </div>
          </div>
        </DashboardFormSection>
      )}
    </Translation>
  );
};

SignupSubscribersList.propTypes = {
  fetchSignupSubscribersList: PropTypes.func.isRequired,
  clearSignupSubscribersList: PropTypes.func.isRequired,
  fetchSignupSubscribersCsv: PropTypes.func.isRequired,
  clearFetchSignupSubscribersCsv: PropTypes.func.isRequired,
  me: PropTypes.object,
  signupSubscribersList: PropTypes.object,
  signupSubscribersListError: PropTypes.object,
  signupSibscribersCsv: PropTypes.object,
};

SignupSubscribersList.defaultProps = {
  me: null,
  signupSubscribersList: null,
  signupSubscribersListError: null,
  signupSibscribersCsv: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    signupSubscribersList: state.emailSignupGenerator.signupSubscribersList,
    signupSubscribersListError: state.emailSignupGenerator.signupSubscribersListError,
    signupSibscribersCsv: state.emailSignupGenerator.signupSibscribersCsv,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchSignupSubscribersList,
    clearSignupSubscribersList,
    fetchSignupSubscribersCsv,
    clearFetchSignupSubscribersCsv,
  },
)(SignupSubscribersList);
